// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"961":"d08b9b4f9163f7a3ed23","5338":"92ae249abe4eb972a92e"}[chunkId] + ".js";
};